/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFold = createReactComponent("fold", "IconFold", [
  ["path", { d: "M12 3v6l3 -3m-6 0l3 3", key: "svg-0" }],
  ["path", { d: "M12 21v-6l3 3m-6 0l3 -3", key: "svg-1" }],
  ["path", { d: "M4 12l1 0", key: "svg-2" }],
  ["path", { d: "M9 12l1 0", key: "svg-3" }],
  ["path", { d: "M14 12l1 0", key: "svg-4" }],
  ["path", { d: "M19 12l1 0", key: "svg-5" }]
]);

export { IconFold as default };
//# sourceMappingURL=IconFold.js.map
